import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import Header from "./navigation/Header";
import {getFlashcardsByCourse} from "../services/TermRepository";
import {FlashCardArray} from "react-flashcards";
import {SimpleGrid} from "./SimpleGrid";
import {FaAngleDoubleLeft} from "react-icons/fa";


function Flashcard(){

    const params = useParams();
    const [terms, setTerms] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState([]);

    useEffect(() => {
        if(params.hasOwnProperty("courseId")) {
            getFlashcardsByCourse(params.courseId).then(result => {
                setTerms(result.flashcardsGrouped)
            })
        }
    }, []);

    function convertFlashcards(group) {
        return group.map((term, idx) => {
            return {id: idx, front: (<h1>{term.term}</h1>), back: (<p className={"p-5"}>{term.definition}</p>), height:"50vh", width:"50vh", label:""}
        })

    }


    if(selectedGroup.length === 0) {
        return (
            <div className={"bg-white"}>
                <Header/>

                <div className={"container pt-5"}>
                    <SimpleGrid fill={true} rowSize={4} margin={3}>
                        {
                            terms.map(group =>  (
                                <div className={"border rounded p-3 d-flex align-items-center text-center justify-content-center "+(group.terms.length > 0 ? "bg-warning border-dark" : "bg-light")}
                                     style={{minHeight:"15vh", height:"15vh"}}
                                     onClick={() => setSelectedGroup(group)}>
                                    <h3>{group.moduleName}</h3>
                                </div>
                            ))
                        }
                    </SimpleGrid>
                </div>
            </div>
        );
    }else {
        return (
            <div className={"bg-light"}>
                <Header/>
                <div className={"text-center pt-4"}>
                    <button className={"btn btn-dark"} onClick={() => setSelectedGroup([])}>
                        <FaAngleDoubleLeft size={16} className={"me-2"}/>
                        <label>Tilbake til oversikt</label>
                    </button>
                </div>
                <div className={"container d-flex pt-5 "} style={{minHeight:"90vh"}} >
                    <FlashCardArray cards={convertFlashcards(selectedGroup.terms)} label={""} timerDuration={10} showCount={true}  />

                </div>
            </div>


        );
    }

}

export default Flashcard;